import { CultureInfo } from '../culture-info.model';
import { CultureInfoPt } from './pt';

/**
 * @ignore
 */
export const CultureInfoPtMZ: CultureInfo = {
  name: 'pt-MZ',
  displayName: 'português (Moçambique)',
  iso3LanguageCode: 'por',
  iso2LanguageCode: 'pt',
  ietfLanguageTag: 'pt-MZ',
  parent: CultureInfoPt
};
